<template>
  <div class="contents">
    <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
  </div>
</template>
<script>
export default {
  name: 'Redirect',
  props: {
    imageNo: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      writeImageNo: this.imageNo
    }
  },
  mounted: function () {
    this.debug('リダイレクト遷移 : props: { imageNo : ' + this.writeImageNo + ' }')
    this.$router.push({ name: 'Main', props: { imageNo: this.writeImageNo } })
  }
}
</script>
<style lang="scss" scoped>
  .md-progress-spinner {
    margin: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Redirect.vue